import { render, staticRenderFns } from "./PxSituacaoUserAprovacao.vue?vue&type=template&id=1e66d250&"
import script from "./PxSituacaoUserAprovacao.vue?vue&type=script&lang=js&"
export * from "./PxSituacaoUserAprovacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports